/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Marketplace_Seo_Spain_Guide_Experiences_TitleInputs */

const es_marketplace_seo_spain_guide_experiences_title = /** @type {(inputs: Marketplace_Seo_Spain_Guide_Experiences_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Excursiones en barco y experiencias náuticas`)
};

const gl_marketplace_seo_spain_guide_experiences_title = /** @type {(inputs: Marketplace_Seo_Spain_Guide_Experiences_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Excursiones en barco e experiencias náuticas`)
};

const en_marketplace_seo_spain_guide_experiences_title = /** @type {(inputs: Marketplace_Seo_Spain_Guide_Experiences_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Boat trips and nautical experiences`)
};

/**
* | output |
* | --- |
* | "Boat trips and nautical experiences" |
*
* @param {Marketplace_Seo_Spain_Guide_Experiences_TitleInputs} inputs
* @param {{ locale?: "es" | "gl" | "en" }} options
* @returns {LocalizedString}
*/
export const marketplace_seo_spain_guide_experiences_title = /** @type {((inputs?: Marketplace_Seo_Spain_Guide_Experiences_TitleInputs, options?: { locale?: "es" | "gl" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Marketplace_Seo_Spain_Guide_Experiences_TitleInputs, { locale?: "es" | "gl" | "en" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "gl") return gl_marketplace_seo_spain_guide_experiences_title(inputs)
	if (locale === "en") return en_marketplace_seo_spain_guide_experiences_title(inputs)
	return es_marketplace_seo_spain_guide_experiences_title(inputs)
});